// extracted by mini-css-extract-plugin
export default {"main-container":"r+ro9746FI9ZcnYNuPxNgw==","container":"_1J+MTMa2EUH2BSI9yLZTlg=="};